import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { getPostLoginPath } from "../utils/postLoginPath";

const AuthRoute = () => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const location = useLocation();
  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : null;

  if (authStatus === "authenticated" && user) {
    // Return to the protected page they came from (if their role allows it),
    // otherwise to their role's home page
    const target = getPostLoginPath(user.userGroup || [], location.state?.from);
    return <Navigate to={target} replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
